import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';

import _ from 'lodash';

@Component({
  selector: 'app-floorplan-edit-sidebar',
  templateUrl: './floorplan-edit-sidebar.component.html',
  styleUrls: ['./floorplan-edit-sidebar.component.scss']
})
export class FloorplanEditSidebarComponent implements OnInit, OnChanges {
  @Input() showHotspot;
  @Input() mediaData;
  @Input() floorPlanData;
  @Input() currentSelectedHotspot;
  @Output() showHotspotEmit = new EventEmitter();
  @Output() closeFoorPlanEmit = new EventEmitter();
  @Output() createHotspotEmit = new EventEmitter();
  @Output() updateHotspotEmit = new EventEmitter();
  @Output() deleteHotspotEmit = new EventEmitter();

  createHotspotForm: FormGroup;
  accessToken: any;
  isSubmitting = false;
  isSubmitted = false;
  imageLoader = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  selectedMedia: any;
  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.createHotspotsFormInit();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.currentSelectedHotspot && changes.currentSelectedHotspot.currentValue) {
      this.resetFormValues(changes.currentSelectedHotspot.currentValue);
    } else {
      this.resetFormValues(undefined);
    }
  }

  createHotspotsFormInit() {
    this.createHotspotForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(40)]],
      image_id: ['', Validators.required]
    });
  }

  addHotspot() {
    this.showHotspot = !this.showHotspot;
    this.showHotspotEmit.emit(this.showHotspot);
  }

  closeFoorPlan() {
    this.closeFoorPlanEmit.emit(false);
  }

  deleteHotspot() {
    this.closeFoorPlanEmit.emit(true);
  }

  selectImage(media) {
    this.selectedMedia = media;
    this.createHotspotForm.get('image_id').setValue(this.selectedMedia.uuid);
  }

  submit(value) {
    if (!this.createHotspotForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.position = {
      x: this.currentSelectedHotspot.position.x,
      y: this.currentSelectedHotspot.position.y,
      z: 0
    };
    if (this.currentSelectedHotspot.uuid) {
      this.updateHotspots(data);
    } else {
      this.createHotspots(data);
    }
  }

  createHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.createFlooplanHotspot({
      Authorization: this.accessToken,
      id: this.floorPlanData.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'New hotspot was successfuly created.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.createHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  updateHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateFlooplanHotspot({
      Authorization: this.accessToken,
      id: this.currentSelectedHotspot.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Hotspot was successfuly updated.';
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.updateHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues(undefined);
  }

  resetFormValues(data) {
    if (!data) {
      this.createHotspotForm.reset({
        title: '',
        image_id: '',
      });
    } else {
      this.createHotspotForm.reset({
        title: data.title,
        image_id: data.image_id,
      });
      this.selectedMedia = _.find(this.mediaData, {uuid: data.image_id});
    }
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating hotspot.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  modalCloseEmit(hotspot) {
    if ($('#deleteModal')) {
      $('#deleteModal').modal('hide');
    }
    if (hotspot) {
      this.deleteHotspotEmit.emit(hotspot);
    }
  }

}
